<template>
  <div class="chart-bar">
    <div class="title">
      <span>{{ title }}</span>
    </div>
    <div class="chart-con">
      <v-chart ref="bar-chart" :id="chartId" class="bar-chart" :options="chartOption" style="height: 100%;width: 100%"/>
    </div>
  </div>
</template>

<script>
import drawBar from '../chartJs/bar';
import { getBarData } from '@/api/getChartData';
import echarts from 'echarts';
export default {
  name: 'ChartBar',
  props: {
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    apiName: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    chartId: {
      type: String,
      default: 'bar-chart',
    },
    yearP: {
      type: Number,
      default: 2023,
    },
  },
  data() {
    return {
      chartOption: null,
      chartData: null,
    };
  },
  methods: {
    getData() {
      if (!this.name) return;
      let chart = echarts.init(document.getElementById(this.chartId));
      this.$api.screen[this.apiName]({
        endYear: this.yearP,
      }).then((res) => {
        let { data } = res.data;
        let names = [],
          listData = {};
        if (data && data.yData?.length) {
          let fI = 0,
            lI = data.yData[0].data.length;
          names = data.yData.map((item) => {
            listData[item.name] = item.data;
            const firstIndex = item.data.findIndex((x) => x !== null && x !== '');
            const lastIndex = item.data.findLastIndex((x) => x !== null && x !== '') + 1;
            if (firstIndex !== -1 && firstIndex > fI) fI = firstIndex;
            if (lastIndex !== -1 && (lI === item.data.length || lastIndex > lI)) lI = lastIndex;
            return item.name;
          });
          listData['年份'] = data.xData;
          for (const key in listData) {
            if (Object.hasOwnProperty.call(listData, key)) {
              const element = listData[key];
              listData[key] = element.slice(fI, lI);
            }
          }
        }
        let list = {
          yAxis: {
            name: '单位：' + (this.name === 'specialNew' || this.name === 'highTech' ? '家' : '亿元'),
          },
          names: ['总数'],
          // colorOpacity: true,
          data: [],
        };
        if (this.type === 'multi') {
          list.names = names;
          list.showLabel = this.showLabel;
        }
        for (let i = 0; i < listData['年份'].length; i++) {
          let obj = {
            年份: listData['年份'][i],
          };
          for (let key in listData) {
            obj[key] = listData[key][i];
          }
          list.data.push(obj);
        }
        this.chartData = list;
        this.chartOption = drawBar(list);

        this.$nextTick(() => {
          this.$refs['bar-chart'].resize()
        })

        let _this = this;
        chart.on('click', function (params) {
          _this.$emit('click-chart', params);
        });
      });

      // getBarData(this.name).then(res => {
      //   let year = new Set();
      //   let names = new Set();
      //   let data = [];
      //   res.RECORDS.map((item) => {
      //     year.add(item['年份']);
      //     names.add(item['指标']);
      //     data.push(item['总数'])
      //   });
      //
      //   this.$nextTick(() => {
      //     let list = {
      //       yAxis: {
      //         name: '单位：' + (this.name === 'specialNew' || this.name === 'highTech' ? '家' : '亿元')
      //       },
      //       names: ['总数'],
      //       // colorOpacity: true,
      //       data: []
      //     };
      //     let dataObj = {};
      //     year = Array.from(year)
      //     dataObj.year = year;
      //     if (this.type === 'multi') {
      //       names = Array.from(names);
      //       list.names = names;
      //       list.showLabel = this.showLabel;
      //       dataObj.private = this.filterData(res.RECORDS, names[0], '总数', '指标');
      //       dataObj.individual = this.filterData(res.RECORDS, names[1], '总数', '指标');
      //       for (let i = 0; i < dataObj.year.length; i++) {
      //         let obj = {
      //           年份: year[i],
      //         };
      //         obj[names[0]] = dataObj.private[i];
      //         obj[names[1]] = dataObj.individual[i];
      //         list.data.push(obj)
      //       }
      //       this.chartData = list;
      //       this.chartOption = drawBar(list)
      //       return;
      //     }
      //     for (let i = 0; i < year.length; i++) {
      //       list.data.push({
      //         年份: year[i],
      //         总数: data[i]
      //       });
      //     }
      //     this.chartData = list;
      //     this.chartOption = drawBar(list)
      //   })
      // })
    },
    filterData(data, name, keyName, label) {
      let arr = [];
      for (let key = 0; key < data.length; key++) {
        if (data[key][label] === name) {
          arr.push(Number(data[key][keyName]));
        }
      }
      return arr;
    },
    setInterData() {
      this.$nextTick(() => {
        this.$refs['bar-chart'].clear();

        this.chartOption = drawBar(this.chartData, true);
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.chart-bar {
  .chart-box();
}
</style>
